var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.overlays),function(overlay){return _c('GmapGroundOverlay',{key:overlay.image,attrs:{"source":overlay.image,"bounds":overlay.bounds,"opacity":1,"is-shown":overlay.isShown}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }